export default __webpack_public_path__ + "static/media/or_1.658cea5c.mp3";